import type { CSSProperties } from 'react';
import arrowRaw from '@/assets/svg/arrow.svg?raw';
import styles from './index.module.scss';

export interface ArrowProps {
  className?: string;
  /** 旋转角度（度），用于方向控制，如 180 = 朝左 */
  rotate?: number;
  /** 描边颜色，写入 currentColor；也可由 className 的 color 覆盖 */
  color?: string;
  /** 对辅助技术隐藏（纯装饰图标建议开启） */
  'aria-hidden'?: boolean | 'true' | 'false';
}

/**
 * 箭头图标：内联 assets/svg/arrow.svg（stroke=currentColor），
 * 通过 color / className / width / height 自定义颜色与尺寸。
 */
export default function Arrow({ className, rotate = 0, color, 'aria-hidden': ariaHidden }: ArrowProps) {
  const style: CSSProperties = {};
  if (rotate) style.transform = `rotate(${rotate}deg)`;
  if (color) style.color = color;

  return (
    <span
      className={`${styles.root}${className ? ` ${className}` : ''}`}
      style={Object.keys(style).length ? style : undefined}
      aria-hidden={ariaHidden}
      dangerouslySetInnerHTML={{ __html: arrowRaw }}
    />
  );
}
